
import i18n from '@/plugins/i18n';
import numeral from "numeral";

export default [
    {
        name: "channel",
        // title: i18n.t('Channel'),
        title:i18n.t('Payments'),
        visible: true,
    },
    {
        name: "orderQty",
        // title: i18n.t('Channel'),
        title:i18n.t('Number of orders'),
        sortField: "orderQty",
        visible: true,
        formatter (value) {
            return numeral(value).format("0,0")
        }
        
    },
    {
        name: "productQty",
        // title: i18n.t('Channel'),
        title:i18n.t('Number Product'),
        sortField: "productQty",
        visible: true,
        formatter (value) {
            return numeral(value).format("0,0")
        }
    },
    {
        name: "sales",
        // title: i18n.t('Channel'),
        title:i18n.t('Sales'),
        sortField: "ordesalesr_qty",
        visible: true,
        formatter (value) {
            return '฿'+Number(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
    },
    {
        name: "growthRate",
        // title: i18n.t('Channel'),
        title:i18n.t('Growth Rate')+" (%)",
        sortField: "growthRate",
        visible: true,
    },
    
];



// WEBPACK FOOTER //
// ./src/components/tenancy/admin/report/finance/table/Fields.js